"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeBillingInformationValidationStatus = computeBillingInformationValidationStatus;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const utils_1 = require("@daytrip/utils");
const responseGenerator = (status) => ({
    billingInfoValidationStatus: status,
    isBillingInfoValid: status === legacy_enums_1.BillingInformationValidationStatus.Valid,
});
function computeBillingInformationValidationStatus(authenticatedUser, billingInformationId) {
    if (!authenticatedUser) {
        return responseGenerator(legacy_enums_1.BillingInformationValidationStatus.Valid);
    }
    const isHyperwallet = authenticatedUser.payoutType === legacy_enums_1.PayoutType.Hyperwallet;
    const isCompleteMangopay = authenticatedUser.activeMangopayInformation &&
        authenticatedUser.activeMangopayInformation.approvedAt &&
        authenticatedUser.activeMangopayInformation.userStatus !== legacy_enums_1.MangopayUserStatus.Pending &&
        authenticatedUser.activeMangopayInformation.recipients.some((r) => r.status === legacy_enums_1.MangopayRecipientStatus.Active);
    const isDriverValid = isCompleteMangopay || isHyperwallet;
    if (isDriverValid) {
        return responseGenerator(legacy_enums_1.BillingInformationValidationStatus.Valid);
    }
    if (authenticatedUser.billingInformation.length === 0) {
        return responseGenerator(legacy_enums_1.BillingInformationValidationStatus.MissingBillingInformation);
    }
    // if no billingInformationId passed, use the active billing information
    const targetBi = billingInformationId
        ? authenticatedUser.billingInformation.find((bi) => bi._id === billingInformationId)
        : authenticatedUser.billingInformation.find((bi) => bi.isActive);
    if (!targetBi) {
        if (billingInformationId) {
            return responseGenerator(legacy_enums_1.BillingInformationValidationStatus.MissingBillingInformation);
        }
        if (authenticatedUser.billingInformation.filter((bi) => bi.isActive).length === 0) {
            return responseGenerator(legacy_enums_1.BillingInformationValidationStatus.MissingActiveBillingInformation);
        }
    }
    if (authenticatedUser.payoutType === legacy_enums_1.PayoutType.Mangopay) {
        const targetMangopayInformation = authenticatedUser.mangopayInformation?.find((mi) => mi.billingInformationId === targetBi._id);
        if (!targetBi.address.addressLine1 ||
            !targetBi.address.city ||
            !targetBi.address.postalCode ||
            !targetBi.address.countryId ||
            !targetBi.address.region) {
            return responseGenerator(legacy_enums_1.BillingInformationValidationStatus.MissingRepresentativeAddress);
        }
        if ((0, utils_1.isUndefinedOrNull)(targetMangopayInformation)) {
            return responseGenerator(legacy_enums_1.BillingInformationValidationStatus.MissingMangopayInformation);
        }
        if (targetMangopayInformation?.userStatus === legacy_enums_1.MangopayUserStatus.Pending) {
            return responseGenerator(legacy_enums_1.BillingInformationValidationStatus.PendingMangopayAction);
        }
        if (!targetMangopayInformation?.recipients.some((r) => r.status === legacy_enums_1.MangopayRecipientStatus.Active)) {
            return responseGenerator(legacy_enums_1.BillingInformationValidationStatus.PendingMangopayRecipientAction);
        }
        const isMissingDocuments = targetBi.documents.length === 0;
        if (isMissingDocuments) {
            return responseGenerator(legacy_enums_1.BillingInformationValidationStatus.MissingDocuments);
        }
        if ((0, utils_1.isUndefinedOrNull)(targetMangopayInformation.approvedAt)) {
            return responseGenerator(legacy_enums_1.BillingInformationValidationStatus.WaitingApproval);
        }
    }
    return responseGenerator(legacy_enums_1.BillingInformationValidationStatus.Valid);
}
//# sourceMappingURL=computeBillingInformationValidationStatus.js.map